/* eslint-disable spire/export-styles */
import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getHomePageUrl, getLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import { MainNavigationStyles, MappedLink } from "@insite/content-library/Widgets/Header/MainNavigation";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Img from "@insite/mobius/Img";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Menu from "@insite/mobius/Menu";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import { useHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
// import Popover from "@insite/mobius/Popover";
import Popover from "@tSchaedlerYesco/Widgets/CustomPopOver";
import * as React from "react";
import { connect } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

interface MainNavigationItemProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement>;
    viewAllCategoryLink: PageLinkModel | undefined;
    isOpen: boolean;
    productLink: PageLinkModel | undefined;
    displayChangeCustomerLink: boolean;
    customMenuImage?: string;
    label?: string;
    BTNlink?: LinkFieldValue;
    customBtnlabel?: string;
    customBtnlink?: LinkFieldValue;
}
const mapStateToProps = (state: ApplicationState) => ({
    state,
});

type Props = MainNavigationItemProps & HasHistory & ReturnType<typeof mapStateToProps>;

interface State {
    hover: boolean;
    isClassNameAdded?: boolean;
    menuItemImage?: string;
}
class MainNavigationItem extends React.Component<ThemeProps<BaseTheme> & Props, State> {
    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();
    constructor(props: ThemeProps<BaseTheme> & Props) {
        super(props);

        this.state = {
            hover: false,
            isClassNameAdded: false,
        };
    }
    disableBreadcrumbFunction = () => {
        const disableBreadcrumb: HTMLSelectElement | null = document.querySelector(
            '[data-test-selector="pageBreadcrumbs"] a:nth-of-type(2)',
        );
        if (disableBreadcrumb) {
            if (disableBreadcrumb.innerText === "Resources") {
                disableBreadcrumb.classList.add("disable-breadcrumb");
            } else {
                disableBreadcrumb.classList.remove("disable-breadcrumb");
            }
        }
    };

    UNSAFE_componentWillMount(): void {
        setMainNavigation({
            close: () => {
                this.closePopover();
            },
            openMenu: (index: number) => {
                this.openPopover();
            },
        });
    }

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    hoverOn = () => {
        this.setState({ hover: true });
    };
    hoverOff = () => {
        this.setState({ hover: false });
    };

    redirectURLButton = () => {
        if (this.props.BTNlink) {
            const link = getLink(this.props.state, this.props.BTNlink);
            if (link?.url) {
                this.props.history.push(link.url);
            }
        }
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    addClassToHideSubmenu = () => {
        this.setState({
            isClassNameAdded: true,
        });
    };

    render() {
        const {
            styles,
            link,
            index,
            customBtnlabel,
            customBtnlink,
            customMenuImage,
            isOpen,
            viewAllCategoryLink,
            theme: {
                breakpoints: { maxWidths },
            },
            BTNlink,
            productLink,
        } = this.props;
        const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading = hasChildren && link.childrenType === "CascadingMenu";
        const isMega = hasChildren && link.childrenType === "MegaMenu";
        const product = siteMessage("Products");

        let menuLink = (
            <Link
                className="menu-item"
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href={link.url}
                target={link.openInNewWindow ? "_blank" : ""}
            >
                {link.title}
                {isCascading && downIcon}
            </Link>
        );
        if (isMega || link.url === "") {
            menuLink = (
                <Link
                    onClick={this.closePopover}
                    className="menu-item"
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                    href={link.title === product ? productLink && productLink.url : link.url}
                >
                    {link.title}
                    {(isCascading || isMega) && downIcon}
                </Link>
            );
        }

        let menuItem = menuLink;

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <Menu
                    data-test-selector={`mainNavigationItem_${index}`}
                    isOpen={isOpen || undefined}
                    descriptionId={`${link.title}_${index}`}
                    menuItems={link.children}
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    {...menuProps}
                    {...styles.cascadingMenu}
                    className={this.state.isClassNameAdded ? "hidesubmenu" : ""}
                    onMouseOver={() => {
                        this.setState({
                            isClassNameAdded: false,
                        });
                    }}
                    onMouseOut={() => {
                        this.setState({
                            isClassNameAdded: true,
                        });
                    }}
                />
            );
        }

        if (isMega) {
            menuItem = (
                <Popover
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    contentBodyProps={{
                        ...styles.megaMenu?.contentBodyProps,
                        _width: 1140,
                        as: "div",
                        css: css`
                            display: flex;
                            gap: 30px;
                            /* padding: 20px; */
                            div {
                                padding: 10px;
                            }
                        `,
                    }}
                    controlsId={`${index}_${link.title}`}
                    ref={this.popover}
                    positionFunction={(element: React.RefObject<HTMLUListElement>) => {
                        if (this.props.container.current?.offsetParent) {
                            const parentPosition = this.props.container.current.getBoundingClientRect();
                            const rect = element.current?.getBoundingClientRect();
                            const top = rect ? rect.top + (rect.height > 100 ? styles.menuHeight : rect.height) : 0;
                            const cartWidth = 150;
                            const breakpointMaxWidth = maxWidths.find((value: number, index: number) => {
                                return (
                                    parentPosition.width + cartWidth <= value &&
                                    parentPosition.width + cartWidth > maxWidths[index - 1]
                                );
                            });

                            const width = breakpointMaxWidth ? breakpointMaxWidth - 30 : parentPosition.width;

                            return {
                                top,
                                position: "fixed",
                                left: parentPosition.left,
                                width: `${width}px`,
                            };
                        }
                        return { position: "absolute" };
                    }}
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                >
                    <Img
                        src={this.props.customMenuImage}
                        css={css`
                            width: 30%;
                            height: auto;
                        `}
                    ></Img>
                    <StyledWrapper
                        css={css`
                            display: flex;
                            flex-direction: column;
                        `}
                    >
                        <GridContainer
                            className="mega-menu-grid-container"
                            data-test-selector={`mainNavigationItem_${index}`}
                            {...styles.megaMenuGridContainer}
                            offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                        >
                            {link
                                .children!.filter(child => !child.excludeFromNavigation)
                                .map((child, index) => (
                                    <GridItem
                                        className="mega-menu-grid-item"
                                        width={(12 / link.numberOfColumns!) as GridWidths}
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={index}
                                        {...styles.megaMenuGridItem}
                                        as="li"
                                    >
                                        <Link
                                            className="mega-menu-heading-link"
                                            {...styles.megaMenuHeading}
                                            href={child.url}
                                            onClick={this.closePopover}
                                        >
                                            {child.title}
                                        </Link>
                                        {child.children && (
                                            <ul data-test-selector={`linksFor_${child.title}`}>
                                                {child.children
                                                    .filter(grandChild => {
                                                        if (grandChild.excludeFromNavigation) {
                                                            return false;
                                                        }
                                                        if (
                                                            grandChild.type === "ChangeCustomerPage" &&
                                                            !this.props.displayChangeCustomerLink
                                                        ) {
                                                            return false;
                                                        }
                                                        if (grandChild.type === "VmiUsersPage") {
                                                            const currentMode = getCookie(NavigationModeCookieName);
                                                            if (!currentMode || currentMode === "Storefront") {
                                                                return false;
                                                            }
                                                        }

                                                        return true;
                                                    })
                                                    .map((grandChild, index) => (
                                                        // eslint-disable-next-line react/no-array-index-key
                                                        <li key={index}>
                                                            <Link
                                                                className="mega-menu-link"
                                                                {...styles.megaMenuLink}
                                                                // onClick={onClick}
                                                                href={grandChild.url}
                                                                data-test-selector={grandChild.title}
                                                            >
                                                                {grandChild.title}
                                                            </Link>
                                                        </li>
                                                    ))}
                                            </ul>
                                        )}
                                    </GridItem>
                                ))}
                        </GridContainer>
                        <StyledWrapper
                            css={css`
                                /* align-items: end; */
                                justify-content: center;
                                display: flex;
                                margin-right: 155px;
                            `}
                        >
                            {this.props.label && (
                                <Button
                                    onClick={this.redirectURLButton}
                                    css={css`
                                        width: auto;
                                        /* margin: auto; */
                                        margin-top: 20px;
                                        span {
                                            color: white !important;
                                        }
                                    `}
                                >
                                    {this.props.label}
                                </Button>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                </Popover>
            );
        }

        return menuItem;
    }
}

export default withTheme(connect(mapStateToProps)(withHistory(MainNavigationItem)));
